import { isEmpty } from 'lodash-es'

import { splitCsvToNumberArray } from '../utils'

const transformToStartTemplateValidationSessionForClusterInput = (
  menuScrapingClusterId,
  values,
) => {
  const data = {
    useMinimumTimeSlotCount: values.useMinimumTimeSlotCount,
    sessionTimeSlotCount: values.sessionTimeSlotCount,
    ignoreWorkingHours: values.ignoreWorkingHours,
  }

  if (!isEmpty(values.menuIds)) {
    data.menuIds = splitCsvToNumberArray(values.menuIds)
  } else {
    data.menuRoles = values.menuRoles
    data.randomlySelectedMenuCount = values.randomlySelectedMenuCount
  }

  return {
    id: menuScrapingClusterId,
    data,
  }
}

export default transformToStartTemplateValidationSessionForClusterInput
